import qs from "qs";
import requestApi from "@/utils/requestApi";
import requestSC from "@/utils/requestSC";
import contractPreview from "@/components/contractPreview/contractPreview.vue";
import HlCart from "../components/hlCart/hlCart.vue";

let timer = null;

export default {
  components: { HlCart, contractPreview },
  data() {
    return {
      // 0：整单发货，1：部分发货
      type: "0",
      orderId: "",
      // 发货方式 SHSM：送货上门 LOGISTICS：物流发货，EXPRESS：快递发货，DELIVERYGOODSHL：货联发货
      logisticsType: "SHSM",
      SHSM: [
        {
          licensePlate: "",
          logisticsInfo: "",
          logisticsCompanyName: "",
        },
      ],
      LOGISTICS: [
        {
          logisticsNum: "",
          logisticsInfo: "",
          logisticsCompanyName: "",
        },
      ],
      EXPRESS: [
        {
          logisticsNum: "",
          logisticsCompanyName: "",
          logisticsCompanyCode: "",
        },
      ],
      DELIVERYGOODSHL: [],
      // 商品信息
      goodsList: [],
      // 凭证
      imgList: [],
      imgListOld: [],
      voucherUrl: "",
      voucherAction: `${process.env.VUE_APP_fileserver}persistentUpload`,
      voucherDialogVisible: false,
      voucherUploadLoading: null,
      // 快递公司
      expressCompanyList: [],
      // 收货人信息
      consigneeInfo: {},
      // 运费
      freightMoney: 0,
      // 货联运输类型
      transType: "specialTrain",
      // 最近使用的物流公司
      recentLogisticsCompany: [],
      // 最近合作过的
      hlRecentCarsList: [],
      // 订单涉及商品调整
      balanceRefundTotal: 0,

      contractPreviewUrl: "",
      contractPreviewSign: false,
      contractPreviewVisible: false,
    };
  },
  async created() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");

    const { type, orderId } = this.$route.query;
    this.type = type;
    this.orderId = orderId;

    const loading = this.$loading({
      lock: true,
      text: "加载中...",
    });

    const [goodsListRes, consigneeInfoRes, expressCompanyRes, imgListRes, recentLogisticsCompanyRes, hlRecentCarsListRes] = await Promise.all([
      requestApi.post(`sctrading/order/ordergoods/selOrderGoodsListByOrderId`, {
        orderId,
      }),
      requestApi.post(`sctrading/order/mj/selOrderDetailByOrderId`, {
        orderId,
      }),
      requestApi.post(`scbasic/dataDictionary/selDataDictionaryItemList`, {
        dictId: "LOGISTICS_COMPANY",
      }),
      requestApi.post(`scbasic/system/systemfile/sel`, {
        busType: "SELLER",
        refId: orderId,
      }),
      requestSC.post(
        `mj/order/manage/getLogisticsList`,
        qs.stringify({
          orderId,
          logisticsType: "LOGISTICS",
        })
      ),
      requestSC.post(
        `mj/order/manage/getHlRecentCarsList`,
        qs.stringify({
          orderId,
        })
      ),
    ]);
    loading.close();

    // 发货商品明细
    const { msg: goodsListMsg, code: goodsListCode, data: goodsListData } = goodsListRes;
    if (goodsListCode == "0") {
      this.goodsList = goodsListData.map((item) => ({
        ...item,
        remark: "",
        finalGoodsQuantity: item.remainGoodsQuantity,
      }));
      this.freightMoney = goodsListData.reduce((pre, cur) => pre + cur.freightMoneyTotal || 0, 0).toFixed(2);
    } else {
      this.$message.error(goodsListMsg);
    }

    // 收货人信息
    const { msg: consigneeInfoMsg, code: consigneeInfoCode, data: consigneeInfoData } = consigneeInfoRes;
    if (consigneeInfoCode == "0") {
      this.consigneeInfo = consigneeInfoData;
    } else {
      this.$message.error(consigneeInfoMsg);
    }

    // 快递信息
    const { msg: expressCompanyMsg, code: expressCompanyCode, data: expressCompanyData } = expressCompanyRes;
    if (expressCompanyCode == "0") {
      this.expressCompanyList = expressCompanyData;
      if (expressCompanyData[0]) {
        this.$set(this.EXPRESS[0], "logisticsCompanyCode", expressCompanyData[0].code);
        this.$set(this.EXPRESS[0], "logisticsCompanyName", expressCompanyData[0].description);
      }
    } else {
      this.$message.error(expressCompanyMsg);
    }

    // 凭证
    const { msg: imgListMsg, code: imgListCode, data: imgListData } = imgListRes;
    if (imgListCode == "0") {
      const imgs = imgListData.map((item) => ({
        url: item.url,
        name: item.url.split("/").pop(),
      }));
      this.imgList = imgs;
      this.imgListOld = imgListData.map((item) => item.url);
    } else {
      this.$message.error(imgListMsg);
    }

    // 最近使用的物流公司
    const { msg: recentLogisticsCompanyMsg, code: recentLogisticsCompanyCode, data: recentLogisticsCompanyData } = recentLogisticsCompanyRes;
    if (recentLogisticsCompanyCode == "0") {
      this.recentLogisticsCompany = recentLogisticsCompanyData;
    } else {
      this.$message.error(recentLogisticsCompanyMsg);
    }

    // 最近合作过的
    const { msg: hlRecentCarsListMsg, code: hlRecentCarsListCode, data: hlRecentCarsListData } = hlRecentCarsListRes;
    if (hlRecentCarsListCode == "0") {
      this.hlRecentCarsList = hlRecentCarsListData.map((item) => ({
        ...item,
        goodsWeight: undefined,
        freightMoney: undefined,
      }));
    } else {
      this.$message.error(hlRecentCarsListMsg);
    }
  },

  mounted() {},
  methods: {
    // 发货
    async logisticsSubmit() {
      const { type, orderId, goodsList, logisticsType, imgList, imgListOld, freightMoney, SHSM, LOGISTICS, EXPRESS, DELIVERYGOODSHL } = this;

      if (goodsList.every((item) => item.finalGoodsQuantity == 0)) {
        this.$message.warning(type == "0" ? "实发数量不能为0" : "本次发货数量不能为0");
        return;
      }

      if (logisticsType == "SHSM" && SHSM.some((item) => !item.logisticsCompanyName)) {
        this.$message.warning("送货人不能为空");
        return;
      }
      if (logisticsType == "SHSM" && SHSM.some((item) => !item.logisticsInfo)) {
        this.$message.warning("联系电话不能为空");
        return;
      }

      if (logisticsType == "LOGISTICS" && LOGISTICS.some((item) => !item.logisticsCompanyName)) {
        this.$message.warning("物流公司不能为空");
        return;
      }
      if (logisticsType == "LOGISTICS" && LOGISTICS.some((item) => !item.logisticsNum)) {
        this.$message.warning("物流单号不能为空");
        return;
      }
      if (logisticsType == "LOGISTICS" && LOGISTICS.some((item) => !item.logisticsInfo)) {
        this.$message.warning("联系电话不能为空");
        return;
      }

      if (logisticsType == "EXPRESS" && EXPRESS.some((item) => !item.logisticsNum)) {
        this.$message.warning("快递单号为空");
        return;
      }

      if (logisticsType == "DELIVERYGOODSHL" && !DELIVERYGOODSHL.length) {
        this.$message.warning("请添加发货信息");
        return;
      }

      if (logisticsType == "DELIVERYGOODSHL" && DELIVERYGOODSHL.some((item) => !item.freightMoney)) {
        this.$message.warning("请输入运费");
        return;
      }

      if (logisticsType == "DELIVERYGOODSHL" && DELIVERYGOODSHL.some((item) => !item.goodsWeight)) {
        this.$message.warning("请输入货品重量");
        return;
      }
      const freightMoneyTotal = Number(DELIVERYGOODSHL.reduce((pre, cur) => pre + Number(cur.freightMoney || 0), 0).toFixed(2));
      if (logisticsType == "DELIVERYGOODSHL" && freightMoneyTotal > Number(freightMoney)) {
        this.$message.warning("货联运费，不可大于订单运费");
        return;
      }

      if ((logisticsType == "SHSM" || logisticsType == "DELIVERYGOODSHL") && !imgList.length) {
        this.$message.warning("上传凭证不能为空");
        return;
      }

      const imgListArr = [];
      imgList.forEach((item) => {
        console.log("itme", item);
        if ((item.response && item.response.data && !imgListOld.includes(item.response.data.url)) || item.url) {
          imgListArr.push(item.url ? item.url : item.response.data.url);
        }
      });
      let logistics = this[logisticsType];
      if (logisticsType == "DELIVERYGOODSHL") {
        logistics = logistics.map((item) => ({
          transType: this.transType,
          licensePlate: item.name,
          driverName: item.relatedName,
          cellPhoneNum: item.tel,
          goodsWeight: item.goodsWeight,
          freightMoney: item.freightMoney,
        }));
      }

      const args = {
        orderId,
        logistics,
        goodsList: goodsList.map((item) => ({
          ogId: item.ogId,
          goodsId: item.goodsId,
          goodsQuantity: item.finalGoodsQuantity,
        })),
        logisticsType,
        imgList: imgListArr,
        sendType: type == "0" ? "all" : "part",
      };

      const confirmSubmit = async () => {
        const loading = this.$loading({
          lock: true,
          text: "加载中...",
        });
        const { msg, code, data } = await requestApi.post(`sctrading/order/logisticsorder/mj/send`, args);

        loading.close();

        if (code == "0") {
          if (data && data.isPass === false) {
            this.$confirm(data.tips || "提示", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                if (data.url) {
                  window.location.href = data.url;
                }
              })
              .catch(() => {});
            return;
          }
          this.$message.success("操作成功");
          this.$router.back();
        } else {
          this.$message.error(msg);
        }
      };

      if (this.contractPreviewSign) {
        confirmSubmit();
        return;
      }

      this.$confirm(
        `为避免交易风险，卖家发货前应上传凭证（物流信息等）。<br />
点击“发货”，即视为您确认按照买家实际下单的具体信息（包括但不限于货品的品类，数量，质量标准，收货人，收货地址等）发货，请勿将货品转让给其他人，且不得进行套现等不正当的行为。 请您务必确保操作准确无误!否则,由此产生的风险及责任将由您自行承担。发货完成后，送货人将可代您补传发货凭证，请知悉。`,
        "温馨提示",
        {
          confirmButtonText: "确认发货",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(async () => {
        if (!this.contractPreviewSign) {
          const loading = this.$loading({
            lock: true,
            text: "加载中...",
          });
          const { msg, code, data } = await requestApi.post(`sctrading/order/logisticsorder/mj/send/preview`, args);
          loading.close();
          if (code == "0") {
            if (!data) {
              confirmSubmit();
              return;
            }
            this.contractPreviewUrl = data;
            this.contractPreviewVisible = true;
          } else {
            this.$message.error(msg);
          }
          return;
        }

        confirmSubmit();
      });
    },

    // 凭证
    voucherRemove(file) {
      const index = this.imgList.findIndex((item) => item.url == file.url);
      this.imgList.splice(index, 1);
    },
    voucherPreview(file) {
      if (/(zip)$/gi.test(file.name)) {
        window.open(file.url);
        return;
      }
      this.voucherUrl = file.url;
      this.voucherDialogVisible = true;
    },
    voucherUploadExceed() {
      this.$message.warning("最多上传30个");
    },
    async voucherUploadSuccess(response, file) {
      timer && clearTimeout(timer);
      timer = setTimeout(() => {
        this.voucherUploadLoading && this.voucherUploadLoading.close();
      }, 1000);
      const { code } = await requestSC.post(
        `rest/order/checkUploadOrderVoucher`,
        qs.stringify({
          orderId: this.orderId,
          voucherImgUrl: response.data.url,
        })
      );
      if (code == "0") {
        this.imgList.push(file);
      } else {
        this.$message.error("有不符合要求的图片上传失败，请上传提货单或司机相关图片");
      }
    },
    voucherUploadChange(file, fileList) {
      if (fileList.every((item) => item.status == "success")) {
        fileList.forEach(async (item, index) => {
          const { code } = await requestSC.post(
            `rest/order/checkUploadOrderVoucher`,
            qs.stringify({
              orderId: this.orderId,
              voucherImgUrl: item.response.data.url,
            })
          );
          if (index == fileList.length - 1) {
            this.voucherUploadLoading && this.voucherUploadLoading.close();
          }
          if (code == "0") {
            this.imgList.push({
              name: item.name,
              uid: item.uid,
              url: item.response.data.url,
            });
          } else {
            this.$message.error("有不符合要求的图片上传失败，请上传提货单或司机相关图片");
          }
        });
      }
    },
    voucherUploadBefore(file) {
      const { size, type } = file;
      console.log("type", type);
      const isVerify = /(jpg|bmp|jpeg|png|zip|x-zip-compressed)$/gi.test(type);
      const isLt3M = size / 1024 / 1024 < 50;

      if (!isVerify) {
        this.$message.error("上传必须是JPG/BMP/JPEG/PNG/ZIP格式");
      } else if (!isLt3M) {
        this.$message.error("上传大小不能超过 50MB");
      }
      if (isVerify && isLt3M) {
        this.voucherUploadLoading = this.$loading({
          lock: true,
          text: "加载中...",
        });
      }
      return isVerify && isLt3M;
    },

    // 发货方式-送货上门
    SHSMAdd() {
      this.SHSM.push({
        licensePlate: "",
        logisticsInfo: "",
        logisticsCompanyName: "",
      });
    },
    SHSMRemove(index) {
      this.SHSM.splice(index, 1);
    },
    // 发货方式-物流发货
    LOGISTICSAdd() {
      this.LOGISTICS.push({
        licensePlate: "",
        logisticsInfo: "",
        logisticsCompanyName: "",
      });
    },
    LOGISTICSRemove(index) {
      this.LOGISTICS.splice(index, 1);
    },
    // 发货方式-快递发货
    EXPRESSAdd() {
      const { expressCompanyList } = this;
      this.EXPRESS.push({
        logisticsNum: "",
        logisticsCompanyCode: expressCompanyList[0].code,
        logisticsCompanyName: expressCompanyList[0].description,
      });
    },
    EXPRESSRemove(index) {
      this.EXPRESS.splice(index, 1);
    },
    DELIVERYGOODSUNIONAdd() {
      this.$refs.hlCart.open(this.hlRecentCarsList, this.DELIVERYGOODSHL);
    },
    DELIVERYGOODSUNIONRemove(index) {
      this.DELIVERYGOODSHL.splice(index, 1);
    },

    // 农信货联
    hlFindCar() {
      this.$open(this.consigneeInfo.toHlUrl, { title: "一键找车", target: 1 });
    },

    // 发货数量修改，更改备注
    finalGoodsQuantityChange(currentValue, scope) {
      const { consigneeInfo } = this;
      if (consigneeInfo.paymentType != "1" || consigneeInfo.paymentSt != 9) {
        return;
      }
      const { row, $index } = scope;
      if (currentValue != row.goodsQuantity) {
        this.$set(this.goodsList[$index], "remark", `货款退差额  ￥${(row.sellFactPrice * (row.goodsQuantity - currentValue)).toFixed(2)}`);
      } else {
        this.$set(this.goodsList[$index], "remark", ``);
      }

      this.balanceRefundTotal = this.goodsList
        .reduce((pre, cur) => pre + Number(cur.sellFactPrice * (cur.goodsQuantity - cur.finalGoodsQuantity)), 0)
        .toFixed(2);
    },

    // 快递发货修改
    logisticsCompany(val, index) {
      const { expressCompanyList } = this;
      const obj = expressCompanyList.find((item) => item.code == val);
      this.$set(this.EXPRESS[index], "logisticsCompanyCode", val);
      this.$set(this.EXPRESS[index], "logisticsCompanyName", obj.description);
    },

    // 凭证列表是否可以删除
    voucherUploadDelDisabled(url) {
      if (this.imgListOld.includes(url)) {
        return false;
      }
      return true;
    },

    // 物流公司最近使用
    recentLogisticsCompanySuggestions(queryString, cb) {
      var recentLogisticsCompany = this.recentLogisticsCompany;
      var results = queryString
        ? recentLogisticsCompany.filter((company) => company.logisticsCompanyName.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        : recentLogisticsCompany;
      cb(results);
    },

    // 农信互联-指定车辆或企业运输
    HlCartConfirm(recentCars) {
      console.log("recentCars", recentCars);
      if (recentCars && recentCars.length) {
        this.DELIVERYGOODSHL = recentCars;
      } else {
        this.DELIVERYGOODSHL = [];
      }
    },

    contractPreviewConfirm() {
      this.contractPreviewVisible = false;
      this.contractPreviewSign = true;
      this.logisticsSubmit();
    },
  },
};
